import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import "rc-slider/assets/index.css";
import { Handle } from "rc-slider";
import React, { useState } from "react";
import { throttle } from "../../../utils/throttle";
import { parseIntValue } from "../Range";
import { StyledSlider, StyledTooltip } from "./styles";

var Slider = function Slider(_ref) {
  var values = _ref.values,
      onChange = _ref.onChange,
      value = _ref.value;
  var byIntValues = values.filter(function (v) {
    return v;
  }) // TODO: temp fix of [undefined]
  .reduce(function (acc, cur) {
    return _objectSpread({}, acc, _defineProperty({}, parseIntValue(cur.slug), _objectSpread({}, cur, {
      intValue: parseIntValue(cur.slug)
    })));
  }, {});
  var intValues = Object.values(byIntValues).map(function (v) {
    return v.intValue;
  });
  var min = Math.min.apply(Math, _toConsumableArray(intValues));
  var max = Math.max.apply(Math, _toConsumableArray(intValues));
  var marks = intValues.reduce(function (acc, cur) {
    return _objectSpread({}, acc, _defineProperty({}, cur, undefined));
  }, {});

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      customDragging = _useState2[0],
      setCustomDragging = _useState2[1];

  var onChangeHandler = function onChangeHandler(newValue) {
    onChange(byIntValues[newValue].slug);
  };

  var onBeforeChange = function onBeforeChange() {
    setCustomDragging(true);
  };

  var onAfterChange = function onAfterChange() {
    setCustomDragging(false);
  };

  var handleTooltip = function handleTooltip(props) {
    var index = props.index,
        rest = _objectWithoutProperties(props, ["index"]);

    var showTooltip = value ? parseIntValue(value) !== min && parseIntValue(value) !== max : null;
    return React.createElement(Handle, _extends({
      className: "custom-tooltip",
      vertical: false,
      offset: 0,
      key: index
    }, rest), showTooltip && React.createElement(StyledTooltip, {
      className: customDragging ? "active" : ""
    }, React.createElement("span", null, "".concat(parseInt(value, 10) / 10, " cm"))));
  };

  return React.createElement(StyledSlider, {
    min: min,
    max: max,
    onChange: onChangeHandler,
    marks: marks,
    step: null,
    value: value ? parseIntValue(value) : undefined,
    handle: handleTooltip,
    onBeforeChange: onBeforeChange,
    onAfterChange: throttle(onAfterChange, 100)
  });
};

export { Slider };